// graph/roleAllocation/mutations.js

import { gql } from "graphql-request";

export const ASSIGN_TENANT_USER_TO_ROLE = gql`
  mutation AssignTenantUserToRole($input: AssignTenantUserToRoleInput!) {
    assignTenantUserToRole(input: $input) {
      id
      tenantUserId
      tenantRoleId
      isPrimary
    }
  }
`;

export const MOVE_TENANT_USER_ROLE_ASSIGNMENT = gql`
  mutation MoveTenantUserRoleAssignment($input: MoveTenantUserRoleAssignmentInput!) {
    moveTenantUserRoleAssignment(input: $input) {
      id
      tenantUserId
      tenantRoleId
      isPrimary
    }
  }
`;

export const SET_PRIMARY_TENANT_USER_ROLE_ASSIGNMENT = gql`
  mutation SetPrimaryTenantUserRoleAssignment($input: SetPrimaryTenantUserRoleAssignmentInput!) {
    setPrimaryTenantUserRoleAssignment(input: $input) {
      id
      tenantUserId
      tenantRoleId
      isPrimary
    }
  }
`;

export const REMOVE_TENANT_USER_ROLE_ASSIGNMENT = gql`
  mutation RemoveTenantUserRoleAssignment($input: RemoveTenantUserRoleAssignmentInput!) {
    removeTenantUserRoleAssignment(input: $input) {
      id
    }
  }
`;

export const ASSIGN_SOP_TO_ROLE = gql`
  mutation AssignSOPToRole($input: AssignSOPToRoleInput!) {
    assignSOPToRole(input: $input) {
      id
      projectId
      tenantRoleId
    }
  }
`;

export const MOVE_SOP_ROLE_ASSIGNMENT = gql`
  mutation MoveSOPRoleAssignment($input: MoveSOPRoleAssignmentInput!) {
    moveSOPRoleAssignment(input: $input) {
      id
      projectId
      tenantRoleId
    }
  }
`;

export const REMOVE_SOP_ROLE_ASSIGNMENT = gql`
  mutation RemoveSOPRoleAssignment($input: RemoveSOPRoleAssignmentInput!) {
    removeSOPRoleAssignment(input: $input) {
      id
    }
  }
`;